import api from '../../utils/api';

const API_BASE_URL = "/admin/ADPAcs"; // Adjust to match your backend API

const ADPAcsService = {
  async findAll(recordFilter: Record<string, any>): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`,
      { params: recordFilter, }
    );
    return response.data;
  },

  async getItemById(accessRoleId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${accessRoleId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(accessRoleId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${accessRoleId}`, item);
    return response.data;
  },

  async delete(accessRoleId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${accessRoleId}`);
    return response.data;
  },

  async getDropdown(facilityCode: any): Promise<any> {
    try {
      const response = await api.get(`${API_BASE_URL}/get-dropdown/${facilityCode}`);
      return response.data;
    } catch (error) {
      console.error('Error get:', error);
      throw error;
    }
  }
};



export default ADPAcsService;